import { render } from "./ArticlesContainer.vue?vue&type=template&id=3d6c2c68"
import script from "./ArticlesContainer.vue?vue&type=script&lang=js"
export * from "./ArticlesContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__